import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {},
    sizeItemWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: Spacings.s24,
      '@media screen and (max-width: 768px)': {
        gap: Spacings.s16,
      },
    },
  },
  {
    name: 'category-item',
  },
);

export default useStyles;
